import { render } from "./dealersalesreport.vue?vue&type=template&id=01db87b8"
import script from "./dealersalesreport.vue?vue&type=script&lang=js"
export * from "./dealersalesreport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__